function initRecaptcha() {
    if (typeof grecaptcha === 'undefined' || typeof MyAjax === 'undefined' || !MyAjax.recaptcha_site_key) {
        return;
    }

    grecaptcha.ready(function () {
        function getToken(formId) {
            grecaptcha.execute(MyAjax.recaptcha_site_key, {action: 'submit'})
                .then(function (token) {
                    var inputElement = document.getElementById(formId + '_recaptchaResponse');
                    if (inputElement) {
                        inputElement.value = token;
                    }
                })
                .catch(function (error) {
                    console.error('reCAPTCHA token error:', error);
                });
        }

        getToken('contact');
        getToken('newsletter');

        setInterval(function () {
            getToken('contact');
            getToken('newsletter');
        }, 120000);
    });
}

if (typeof grecaptcha !== 'undefined') {
    initRecaptcha();
} else {
    window.addEventListener('load', initRecaptcha);
}